module.exports = __webpack_public_path__ + "static/media/versace.b93d9382.jpg";